import { render, staticRenderFns } from "./ValidityErrorNotification.vue?vue&type=template&id=1f4ddb53&"
import script from "./ValidityErrorNotification.vue?vue&type=script&lang=js&"
export * from "./ValidityErrorNotification.vue?vue&type=script&lang=js&"
import style0 from "./ValidityErrorNotification.vue?vue&type=style&index=0&lang=stylus&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports